import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { ChevronLeft, ChevronRight, Receipt, Search } from 'lucide-react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function TransactionManagePage() {
  const [loading, setLoading] = useState(false);
  const [transaction, setTransaction] = useState([]);
  const [loadingTransasction, setLoadingTransaction] = useState(false);

  const [periodeStart, setPeriodeStart] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [periodeEnd, setPeriodeEnd] = useState(new Date());
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [keyword, setKeyword] = useState('');

  const [form, setForm] = useState({
    status: null,
    transaction_status: null,
    id: null,
    valid_until: null,
    valid_until_date: null,
    valid_until_time: null,
    id_user: null,
    payment_date: null,
    payment_date_date: null,
    payment_date_time: null,
  });

  useEffect(() => {
    fetchTransaction();
  }, [periodeStart, periodeEnd, statusFilter, page, keyword]);
  const fetchTransaction = async () => {
    setLoadingTransaction(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/datatables/transaction`, {
        periode_start: periodeStart.toISOString().split('T')[0],
        periode_end: periodeEnd.toISOString().split('T')[0],
        status: statusFilter,
        page,
        limit: 10,
        keyword: keyword.trim()
      }, {
        withCredentials: true,
      });
      setTransaction(res.data.data || []);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      Swal.fire('Oops!', err.response?.data?.message || "Silakan coba lagi.", 'error');
    } finally {
      setLoadingTransaction(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    //   if (name === 'valid_until_date' || name === 'valid_until_time') {
    //     const updatedForm = {
    //       ...form,
    //       [name]: value,
    //     };

    //     const { valid_until_date, valid_until_time } = {
    //       ...updatedForm,
    //       [name]: value,
    //     };

    //     if (valid_until_date && valid_until_time) {
    //       const combinedDateTime = new Date(`${valid_until_date}T${valid_until_time}`);
    //       updatedForm.valid_until = combinedDateTime.toISOString();
    //     }

    //     setForm(updatedForm);
    //   } else {
    setForm(prev => ({ ...prev, [name]: value }));
    //   }
  };

  function formatDateToMySQL(date) {
    const pad = (n) => (n < 10 ? '0' + n : n);
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      ' ' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds())
    );
  }
  const updateTransaction = async () => {

    if (selectedOrder.price_duration_type == 'Permanent') { } else {
      if (form.valid_until_date === '') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Tanggal valid tidak boleh kosong!',
        });
        return;
      }

      if (form.valid_until_time === '') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Waktu valid tidak boleh kosong!',
        });
        return;
      }
    }

    // /transaction/update
    const combinedDateTime = new Date(`${form.valid_until_date}T${form.valid_until_time}`);
    const formattedDateTime = formatDateToMySQL(combinedDateTime);

    const combinedDateTime2 = new Date(`${form.payment_date_date}T${form.payment_date_time}`);
    const formattedDateTime2 = formatDateToMySQL(combinedDateTime2);
    let formData = {
      status: form.status,
      transaction_status: form.transaction_status,
      id: form.id,
      valid_until: selectedOrder.price_duration_type == 'Permanent' ? null : formattedDateTime,
      id_user: form.id_user,
      payment_date: formattedDateTime2
    };

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/transaction/update`, formData, { withCredentials: true });
      setShowModal(false);
      fetchTransaction();
      Swal.fire('Berhasil', 'Data berhasil disimpan', 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Oops!', (error.response?.data?.message || "Silakan coba lagi."), 'error');
    }


  }

  return (
    <div className="container-fluid px-0">
      <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <div className="mb-4 flex items-center gap-2 text-slate-800">
          <Receipt size={18} />
          <h4 className="mb-0 text-lg font-semibold">Data Transaksi</h4>
        </div>

        <div className="mb-4 d-flex flex-wrap align-items-end gap-3">
          <div className="min-w-[180px]">
            <label className="form-label mb-1 fw-semibold text-dark">Tanggal Awal</label>
            <DatePicker
              selected={periodeStart}
              onChange={(date) => setPeriodeStart(date)}
              selectsStart
              startDate={periodeStart}
              endDate={periodeEnd}
              className="form-control rounded-lg border-slate-300"
              placeholderText="Periode Awal"
            />
          </div>
          <div className="min-w-[180px]">
            <label className="form-label mb-1 fw-semibold text-dark">Tanggal Akhir</label>
            <DatePicker
              selected={periodeEnd}
              onChange={(date) => setPeriodeEnd(date)}
              selectsEnd
              startDate={periodeStart}
              endDate={periodeEnd}
              className="form-control rounded-lg border-slate-300"
              placeholderText="Periode Akhir"
            />
          </div>
          <div className="min-w-[180px]">
            <label className="form-label mb-1 fw-semibold text-dark">Status</label>
            <select className="form-select rounded-lg border-slate-300" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
              <option value="ALL">Semua Status</option>
              <option value="PENDING">Pending</option>
              <option value="SETTLEMENT">Settlement</option>
              <option value="CANCEL">Cancel</option>
            </select>
          </div>
          <div className="flex-1 min-w-[260px]">
            <label className="form-label mb-1 fw-semibold text-dark">Pencarian</label>
            <div className="relative">
              <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                <Search size={16} />
              </span>
              <input
                type="text"
                className="w-full rounded-xl border border-slate-300 bg-white py-2 pl-10 pr-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                placeholder="Cari berdasarkan nama user, kode transaksi, atau nama paket..."
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="table-responsive rounded-xl border border-slate-300 bg-white mb-3">
          <table className="table table-hover table-striped table-bordered table-sm align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Kode Transaksi</th>
                <th>Nama User</th>
                <th>Tanggal Transaksi</th>
                <th>Valid Until</th>
                <th>Status Pembayaran</th>
                <th>Nama Paket</th>
                <th>Total</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loadingTransasction ? (
                <tr><td colSpan="10" className='text-center'>Memuat...</td></tr>
              ) : transaction.length === 0 ? (
                <tr><td colSpan="10" className='text-center'>Tidak ada data</td></tr>
              ) : (
                transaction.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * 10 + index + 1}</td>
                    <td><b className='fw-bold text-dark'>{item.transaction_id}</b></td>
                    <td>{item.user_name}</td>
                    <td>{new Date(item.transaction_date).toLocaleDateString('id-ID', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      hour12: false
                    })}</td>
                    <td>

                      {
                        item.price_duration_type == "Permanent" ? 'Permanent' : item.valid_until && (
                          <>
                            {new Date(item.valid_until).toLocaleDateString('id-ID', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                            })}
                          </>
                        )
                      }

                    </td>
                    <td><b className={item.transaction_status == 'PENDING' ? 'text-warning' : (item.transaction_status == 'SETTLEMENT' ? 'text-success' : 'text-danger')}>{item.transaction_status}</b></td>
                    <td>{item.price_name}</td>
                    <td>Rp {parseInt(item.price_total).toLocaleString('id-ID')}</td>
                    <td><b className={item.status == 'ACTIVE' ? 'text-success' : 'text-danger'}>{item.status}</b></td>
                    <td>
                      <button className='btn btn-sm btn-dark' onClick={() => {
                        setForm({
                          status: item.status,
                          id: item.id,
                          valid_until: item.valid_until ?? null,
                          transaction_status: item.transaction_status,
                          valid_until_date: item.valid_until ? new Date(item.valid_until).toISOString().split('T')[0] : null,
                          valid_until_time: item.valid_until ? new Date(item.valid_until).toISOString().split('T')[1].substring(0, 5) : null,
                          payment_date_date: item.payment_date ? new Date(item.payment_date).toISOString().split('T')[0] : null,
                          payment_date_time: item.payment_date ? new Date(item.payment_date).toISOString().split('T')[1].substring(0, 5) : null,
                          id_user: item.id_user
                        });
                        setSelectedOrder(item);
                        setShowModal(true);
                      }}>
                        Detail <i className='fa fa-arrow-right'></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-3 d-flex justify-content-start">
          <div className="d-inline-flex align-items-center gap-2 rounded-pill border border-slate-200 bg-white px-2 py-1 shadow-sm">
            <button
              className="btn btn-sm btn-link text-decoration-none text-dark p-1 d-flex align-items-center"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              aria-label="Halaman sebelumnya"
            >
              <ChevronLeft size={18} />
            </button>
            <span className="px-2 small text-muted">{page} / {totalPages}</span>
            <button
              className="btn btn-sm btn-link text-decoration-none text-dark p-1 d-flex align-items-center"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              aria-label="Halaman berikutnya"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

      </div>

      {showModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detail Transaksi</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body row g-2">

                <div className="col-12 mb-3 text-center">
                  <h4 className="fw-bold">{selectedOrder.transaction_id}</h4>
                  {/* <span className={`badge bg-${selectedOrder.transaction_status === 'SETTLEMENT' ? 'success' : selectedOrder.transaction_status === 'PENDING' ? 'warning text-dark' : 'danger'}`}>
                        {selectedOrder.transaction_status}
                      </span> */}
                </div>

                <div className="col-md-6">
                  <strong>Nama User:</strong><br />
                  <label className='text-dark'>{selectedOrder.user_name}</label>
                </div>

                <div className="col-md-6">
                  <strong>Tanggal Transaksi:</strong><br />
                  {new Date(selectedOrder.transaction_date).toLocaleString('id-ID', {
                    day: '2-digit', month: 'short', year: 'numeric',
                    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                  })}
                </div>

                {/* <div className="col-md-6">
                      <strong>Tanggal Pembayaran:</strong><br />
                      {
                        selectedOrder.payment_date && (
                          <>
                            {new Date(selectedOrder.payment_date).toLocaleDateString('id-ID', {
                              day: '2-digit', month: 'short', year: 'numeric',
                              hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                            })}
                          </>
                        )
                      }
                    </div> */}

                <div className="col-md-6">
                  <strong>Tanggal Pembayaran (Date):</strong><br />
                  <input
                    type="date"
                    className="form-control"
                    name="payment_date_date"
                    value={
                      form.payment_date_date
                    }
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <strong>Tanggal Pembayaran (Time):</strong><br />
                  <input
                    type="time"
                    className="form-control"
                    name="payment_date_time"
                    value={
                      form.payment_date_time
                    }
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <strong>Status:</strong><br />
                  <select className="form-control" name="status" value={form.status} onChange={handleChange} required>
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>

                <div className='col-md-6'>
                  <strong>Status Transaksi:</strong><br />
                  <select className="form-control" name="transaction_status" value={form.transaction_status} onChange={handleChange} required>
                    <option value="PENDING">PENDING</option>
                    <option value="SETTLEMENT">SETTLEMENT</option>
                    <option value="CANCEL">CANCEL</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <strong>Berlaku Hingga (Date): *Kosongkan jika durasi Permanen</strong><br />
                  <input
                    type="date"
                    className="form-control"
                    name="valid_until_date"
                    value={
                      form.valid_until_date
                    }
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <strong>Berlaku Hingga (Time): *Kosongkan jika durasi Permanen</strong><br />
                  <input
                    type="time"
                    className="form-control"
                    name="valid_until_time"
                    value={
                      form.valid_until_time
                    }
                    onChange={handleChange}
                  />
                </div>

                <hr className="my-3" />

                <div className="col-12">
                  <h5>Detail Paket</h5>
                </div>

                <div className="col-md-6"><strong>Kode Paket:</strong><br />{selectedOrder.price_code}</div>
                <div className="col-md-6"><strong>Nama Paket:</strong><br />{selectedOrder.price_name}</div>
                <div className="col-md-6"><strong>Durasi:</strong><br />

                  {
                    selectedOrder.price_duration_type === 'Permanent' ? 'Permanent' : `${selectedOrder.price_duration_value} ${selectedOrder.price_duration_type}(s)`
                  }

                </div>
                <div className="col-md-6"><strong>Maks. Sesi:</strong><br />{selectedOrder.price_max_session === -1 ? 'Unlimited' : selectedOrder.price_max_session}</div>
                <div className="col-md-6"><strong>Maks. Chat Attempts:</strong><br />{selectedOrder.price_max_attempt === -1 ? 'Unlimited' : selectedOrder.price_max_attempt}</div>
                <div className="col-md-6"><strong>Voice AI Aktif:</strong><br />
                  <span className={`text-${selectedOrder.price_is_ai_audio_active === 1 ? 'success' : 'danger'}`}>
                    {selectedOrder.price_is_ai_audio_active === 1 ? 'YES' : 'NO'}
                  </span>
                </div>
                <div className="col-md-6"><strong>Maks. Voice Attempts:</strong><br />{selectedOrder.price_max_voice_attempt === -1 ? 'Unlimited' : selectedOrder.price_max_voice_attempt}</div>
                <div className="col-md-6"><strong>Maks. Examination Assistant Attempts:</strong><br />{selectedOrder.price_examination_assist_max === -1 ? 'Unlimited' : selectedOrder.price_examination_assist_max}</div>
                <div className="col-md-6"><strong>Total Harga:</strong><br /><b>Rp. {selectedOrder.price_total.toLocaleString('id-ID')}</b></div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-dark" onClick={() => updateTransaction()}>Simpan</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Tutup</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );

}

export default TransactionManagePage;